export default __webpack_public_path__ + "static/media/hero-main-images.b3e121db.webp";